import { Box, Button, Typography } from '@mui/material';

import { useModalContext } from '@/modals/VNModalProvider';

import VnModalBody from './VnModalBody';
import VnModalFooter from './VnModalFooter';

type DemoData = {
  id: string;
};
const DemoModal = ({ id }: DemoData) => {
  const { onClose } = useModalContext();

  const save = async () => {
    console.log('Saving modal with id:', id);
    await new Promise((res) => setTimeout(res, 1000));
    onClose();
  };

  const cancel = () => {
    console.log('Cancelled');
    onClose();
  };

  return (
    <Box>
      <VnModalBody>
        <Typography variant="h6">Demo Modal Content</Typography>
        <Typography variant="body2">ID: {id}</Typography>
      </VnModalBody>
      <VnModalFooter
        right={
          <>
            <Button variant="contained" color="primary" onClick={save}>
              Okay
            </Button>
            <Button variant="contained" onClick={cancel}>
              Cancel
            </Button>
          </>
        }
      />
    </Box>
  );
};

export default DemoModal;
